import React from 'react';
import { MultiframeMode, getMultiframeModeName } from '../../../models/prediction';
import { ConfigSection } from '../ConfigSection';
import RadioButtonList, { RadioButtonEntry } from '../radioButtonsList';

export interface ConfigMultiframeModeProps {
    multiframeModeList: MultiframeMode[];
    value: MultiframeMode;
    onChange: (value: MultiframeMode) => void;
    disabled: boolean;
}

const MultiframeModeSection: React.FC<ConfigMultiframeModeProps> = ({
    multiframeModeList,
    value: selectedMultiframeMode,
    onChange,
    disabled,
}) => {
    const multiframeModeRadioButtonList: RadioButtonEntry<MultiframeMode>[] = multiframeModeList.map(
        (field) => {
            return { value: field, label: getMultiframeModeName(field) };
        },
    );

    return (
        <ConfigSection title="Multiframe mode">
            <RadioButtonList
                list={multiframeModeRadioButtonList}
                selectedValue={selectedMultiframeMode}
                onChange={onChange}
                disabled={disabled}
            />
        </ConfigSection>
    );
};

export default MultiframeModeSection;
